var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#ffffff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#eeeeee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#eeeeee",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#eeeeee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#f2f2f2",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#f6f6f6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#f2f2f2",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_3",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#f6f6f6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#fbfbfb",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_4",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#fbfbfb",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#eeeeee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#eeeeee",
    stopOpacity: 1
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#f2f2f2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#eeeeee",
    stopOpacity: 1
  })))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#f2f2f2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#f6f6f6",
    stopOpacity: 1
  })))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_3",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#fbfbfb",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#f6f6f6",
    stopOpacity: 1
  })))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_4",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#fbfbfb",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#ffffff",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 405.6C-57.4 372.2 -114.8 338.8 -178.5 309.2C-242.2 279.5 -312.4 253.7 -351.3 202.8C-390.2 151.9 -397.9 76 -405.6 0L0 0Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 324.5C-45.9 297.8 -91.8 271 -142.8 247.3C-193.8 223.6 -249.9 203 -281 162.2C-312.2 121.5 -318.3 60.8 -324.5 0L0 0Z",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 243.4C-34.4 223.3 -68.9 203.3 -107.1 185.5C-145.3 167.7 -187.4 152.2 -210.8 121.7C-234.1 91.1 -238.7 45.6 -243.4 0L0 0Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 162.2C-23 148.9 -45.9 135.5 -71.4 123.7C-96.9 111.8 -124.9 101.5 -140.5 81.1C-156.1 60.8 -159.2 30.4 -162.2 0L0 0Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 81.1C-11.5 74.4 -23 67.8 -35.7 61.8C-48.4 55.9 -62.5 50.7 -70.3 40.6C-78 30.4 -79.6 15.2 -81.1 0L0 0Z",
    fill: "#eeeeee"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -405.6C74.6 -397.1 149.1 -388.6 202.8 -351.3C256.5 -314 289.2 -247.8 319.6 -184.5C349.9 -121.2 377.8 -60.6 405.6 0L0 0Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -324.5C59.7 -317.7 119.3 -310.9 162.2 -281C205.2 -251.2 231.4 -198.3 255.7 -147.6C279.9 -96.9 302.2 -48.5 324.5 0L0 0Z",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -243.4C44.7 -238.3 89.5 -233.2 121.7 -210.8C153.9 -188.4 173.5 -148.7 191.7 -110.7C209.9 -72.7 226.7 -36.3 243.4 0L0 0Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -162.2C29.8 -158.8 59.7 -155.4 81.1 -140.5C102.6 -125.6 115.7 -99.1 127.8 -73.8C140 -48.5 151.1 -24.2 162.2 0L0 0Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -81.1C14.9 -79.4 29.8 -77.7 40.6 -70.3C51.3 -62.8 57.8 -49.6 63.9 -36.9C70 -24.2 75.6 -12.1 81.1 0L0 0Z",
    fill: "#eeeeee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.6931e5bde42c319eeb6128587a827b7b.svg";
export { ForwardRef as ReactComponent };